import { POWERFUL_WOMEN_CATEGORY } from '@/constants';

import { ScreenControlStyle } from './screens/ControlStyle';
import { ScreenDominatrixVisualStyle } from './screens/DominatrixVisualStyle';
import { ScreenEmail } from './screens/Email';
import { ScreenName } from './screens/Name';
import { ScreenSafewordChoice } from './screens/SafewordChoice';
import { SafewordInput } from './screens/SafewordInput';
import { ScreenSettingUpProfile } from './screens/SettingUpProfile';
import { SummaryDeep } from './screens/SummaryDeep';
import { SummaryFinal } from './screens/SummaryFinal';
import { SummaryIntro } from './screens/SummaryIntro';
import { ScreenTools } from './screens/Tools';
import { ScreenVoiceStyle } from './screens/VoiceStyle';
import { ScreenWelcome } from './screens/Welcome';

import type { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: ScreenWelcome,
    images: [],
  },
  control_style: {
    component: ScreenControlStyle,
    images: [],
  },
  dominatrix_visual_style: {
    component: ScreenDominatrixVisualStyle,
    images: [],
  },
  summary_intro: {
    component: SummaryIntro,
    images: [],
  },
  voice_style: {
    component: ScreenVoiceStyle,
    images: [],
  },
  safeword_choice: {
    component: ScreenSafewordChoice,
    images: [],
  },
  safeword_input: {
    component: SafewordInput,
    images: [],
  },
  summary_deep: {
    component: SummaryDeep,
    images: [],
  },
  tools: {
    component: ScreenTools,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  summary_final: {
    component: SummaryFinal,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  control_style: null,
  dominatrix_visual_style: null,
  voice_style: null,
  safeword_choice: null,
  safeword_input: '',
  tools: null,
  name: '',
  ready_to_obey: null,
  email: '',
};

export const HARDCODED_CATEGORIES = [POWERFUL_WOMEN_CATEGORY];
